// extracted by mini-css-extract-plugin
module.exports = {"lock":"Lock_lock__O3CEg","lock-icon":"Lock_lock-icon__4bg8p","lock-button":"Lock_lock-button__1EAPU"};